import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ResizeDirective } from '../../directives/resize.directive';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  standalone: true,
  imports: [NgIf, ResizeDirective, NgFor],
})
export class PictureComponent implements OnChanges {
  @Input() url: string;
  @Input() mobileUrl: string;
  /**
   * Scale of the image between 0 and 1
   */
  @Input() scale: number;
  @Input() width: number;
  @Input() height: number;
  @Input() maxWidth: number;
  @Input() mobileWidth: number;
  @Input() mobileHeight: number;
  @Input() loading = 'lazy';
  @Input() alt: string;
  srcset: { [size: string]: string };
  mobileSrcset: { [size: string]: string };
  fetchPriority: 'auto' | 'high' | 'low' = 'auto';
  _sizes = [3000, 2400, 2000, 1800, 1600, 1400, 1200, 1000, 800, 720, 600, 550, 500, 450, 400, 350, 300];
  sizes: number[];

  private resize(url: string, width: number) {
    url = url.replace('//a.storyblok.com/f/234504', '//assets.picflow.com');
    if (url.includes('//assets.picflow.com')) {
      if (url.includes('.svg')) return url;
      return `${url}/m/${width}x0/filters:quality(90)`;
    }

    const s = url.includes('?') ? '&' : '?';
    return `${url}${s}w=${width}`;
  }

  private getImageWidth(url: string) {
    // matches /1280x960/
    const match = url.match(/\/(\d+)x\d+\//);
    if (match) return parseInt(match[1]);
  }

  private getSizes() {
    const imageWidth = this.getImageWidth(this.url) || Infinity;
    const sizes = [];
    for (const i in this._sizes) {
      const size = this._sizes[i];
      const nextSize = this._sizes[parseInt(i) + 1];
      const fits = !this.maxWidth || nextSize <= Math.min(this.maxWidth / this.scale, imageWidth);
      if (!fits) continue;
      sizes.push(size);
    }
    return sizes;
  }

  ngOnChanges() {
    if (!this.url) return (this.srcset = undefined);
    if (!this.mobileUrl) this.mobileUrl = this.url;
    if (this.loading === 'eager') this.fetchPriority = 'high';
    this.srcset = {};
    this.mobileSrcset = {};
    this.sizes = this.getSizes();

    this.sizes.forEach((size, i) => {
      const sizeKey = size;
      let biggerSize = this.sizes[i - 1];
      if (!biggerSize) return;
      const mobileSize = biggerSize - 30; // 15px padding on each side
      biggerSize = biggerSize * this.scale;
      this.srcset[`size-${sizeKey}`] = `${this.resize(this.url, biggerSize)}, ${this.resize(
        this.url,
        biggerSize * 2
      )} 2x`;
      this.mobileSrcset[`size-${sizeKey}`] = `${this.resize(this.mobileUrl, mobileSize)}, ${this.resize(
        this.mobileUrl,
        mobileSize * 2
      )} 2x`;
    });
  }

  getInSize(src: string, size: number) {
    return this.resize(src, size);
  }
}
